import { useCallback, useEffect, useState } from "react";
import { useRealtimeEvent } from "./RealtimeProvider";
import { usePermissions } from "../Auth/PermissionsContext";
import { contactMessagesClient } from "../Pages/ContactMessages/contactMessagesClient";

/**
 * Compteur vivant des messages de contact « new » pour la pastille de la barre latérale. Un fetch
 * au montage, puis rafraîchi à chaque événement temps réel `notification` du sujet
 * « contact-messages » (un événement d'un autre sujet ne déclenche rien) : la pastille reste juste
 * pour tous les admins sans polling. Zéro quand l'utilisateur ne peut pas lire les messages.
 */
export function useContactBadge(): number {
	const { can } = usePermissions();
	const allowed = can("feature:contact-messages:read");
	const [count, setCount] = useState(0);

	const refresh = useCallback(() => {
		if (!allowed) {
			setCount(0);
			return;
		}
		contactMessagesClient
			.countNew()
			.then((n) => setCount(Number.isFinite(n) ? n : 0))
			.catch(() => {
				/* on garde le dernier compteur connu sur une erreur transitoire */
			});
	}, [allowed]);

	useEffect(() => {
		refresh();
	}, [refresh]);

	// Un nouveau message (ou une invalidation) du sujet « contact-messages » peut changer le compteur.
	// Le payload `invalidated` ne porte pas de topic : on rafraîchit aussi dans ce cas (pas de topic).
	useRealtimeEvent("notification", (payload: any) => {
		if (payload?.topic && payload.topic !== "contact-messages") return;
		refresh();
	});

	return count;
}
